// extracted by mini-css-extract-plugin
export default {"competitionCard":"competitions_competitionCard__0o1uI"};